<template>
  <div class="p-0">
    <div class="add-payment-box">
      <div class="left-side p-0">
        <primary-input
          class="p-0"
          title="ODPŁATNOŚĆ"
          placeholder="Kwota za godzinę opieki"
          :grayInput="true"
          :isRequired="true"
          :size="'small'"
          :type="'number'"
          :min="0"
          @change="(e) => (amount = e)"
        />
      </div>
      <div class="right-side p-0 ml-4 mr-2">
        <dod-custom-date-input
          class="p-0"
          :prePick="getMinDateForNewSchedule()"
          title="OBOWIĄZUJE OD"
          :minDate="getMinDateForNewSchedule()"
          :placeholder="dateFrom"
          :isRequired="true"
          @dateChange="(e) => (dateFrom = e)"
        />
      </div>
    </div>
    <div class="save-payment-button">
      <custom-button
        @click="savePayment"
        :gradient="false"
        :size="'small'"
        :title="'Zapisz'"
        :customStyles="'width: 51px; height:30px'"
      />
    </div>
  </div>
</template>

<script>
import DodCustomDateInput from "./DodCustomDateInput.vue";
import moment from "moment";
import PrimaryInput from "../PrimaryInput.vue";
import CustomButton from "../CustomButton.vue";
export default {
  components: { DodCustomDateInput, PrimaryInput, CustomButton },
  name: "AddPayment",
  props: ["customerId"],
  emits: ["paymentAdded"],
  data() {
    return {
      amount: 0,
      dateFrom: "",
    };
  },
  mounted() {
    this.dateFrom = this.getMinDateForNewSchedule();
  },
  methods: {
    getMinDateForNewSchedule() {
      return moment().add(1, "day").format("YYYY-MM-DD");
    },

    async savePayment() {
      if (!this.dateFrom || !this.amount) {
        this.$notify({
          group: "error",
          text: "Uzupełnij wymagane pola",
        });
        return;
      }
      const response = await this.$store.dispatch("addCustomerPayment", {
        customerId: this.customerId,
        dateFrom: this.dateFrom,
        amount: Number(this.amount),
      });
      if (response) {
        this.$emit("paymentAdded");
      }
    },
  },
};
</script>

<style scoped>
.add-payment-box {
  display: flex;
  padding: 0;
  margin-top: 2rem;
}
.save-payment-button {
  display: flex;
  margin: 0;
  padding: 0;
}
</style>